<template>
    <pendo-router-link
        v-pendo-tooltip="{
            classes: 'side-nav-tooltip',
            content: tooltipContent,
            placement: 'right',
            arrow: true,
        }"
        pendo-analytics="guides-nav-item-upsell"
        class="nav-option"
        :class="{ selected, expanded }"
        :data-cy="isBasicUpgrade ? 'basic-upsell' : 'pro-upsell'"
        :to="route"
        :aria-label="label"
        @click="$emit('toggle', $event)"
        @keyup.enter="$emit('toggle', $event)">
        <div class="nav-icon">
            <guides-nav-icon />
        </div>
        <div
            v-show="expanded"
            class="nav-label">
            <span class="label-text">{{ label }}</span>
            <upsell-tag />
        </div>
    </pendo-router-link>
</template>

<script>
import PendoRouterLink from '@/vue-router/pendo-router-link.vue';
import { PendoTooltip } from '@pendo/components-vue3';
import GuidesNavIcon from '@/side-nav/components/nav-icons/guides-nav-icon.vue';
import UpsellTag from '@/common/tags/upsell-tag.vue';

export default {
    name: 'Guides',
    components: {
        PendoRouterLink,
        GuidesNavIcon,
        UpsellTag,
    },
    directives: {
        PendoTooltip,
    },
    props: {
        selected: {
            type: Boolean,
            default: false,
        },
        isBasicUpgrade: {
            type: Boolean,
            default: false,
        },
        isProUpgrade: {
            type: Boolean,
            default: false,
        },
        expanded: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['toggle'],
    computed: {
        label () {
            return this.isProUpgrade ? this.$t('sideNav.Guides Pro') : this.$t('sideNav.Guides');
        },
        route () {
            if (this.isProUpgrade) {
                return { name: 'GuidesProUpsell' };
            }

            return { name: 'GuidesBasicUpsell' };
        },
        tooltipContent () {
            if (this.expanded) return '';

            if (this.isProUpgrade) {
                return this.$t('sideNav.Available upgrade: Guides Pro');
            }

            return this.isBasicUpgrade ? this.$t('sideNav.Available upgrade: Guides') : this.label;
        },
    },
};
</script>

<style scoped lang="less">
@import '@/side-nav/nav.style.less';
</style>
